import axios from "axios";

const apiClient = axios.create({
  baseURL: "/api/rating",
  header: {
    "Content-Type": "application/json",
  },
});

const sendFeedBack = async (data) => {
  return apiClient.post("/", data);
};
export const ratingService = {
  sendFeedBack,
};
